export const MessagingTopics = {
  WEBCHAT_POSITION: '/topic/visitor-position',
  TASK_CONVERSATION_MESSAGE: '/webchat/task-conversation/',
  TASK_CONVERSATION_IS_TYPING: '/task-conversation/is-typing/',
  TASK_STATUS: '/user/queue/task-status',
};
